import { getUserModuleState, UserState } from "#login/store/reducers";
import { createSelector } from "@ngrx/store";
import * as registerReducers from "#login/store/reducers/login-register.reducer";

// ------Register SELECTORS------
export const getRegisterState = createSelector(
    getUserModuleState,
    (state: UserState) => state.register
);

export const getAuthorized = createSelector(
    getRegisterState,
    registerReducers.getAuthorized
);

export const getEmail = createSelector(
    getRegisterState,
    registerReducers.getEmail
);

export const getInviteHash = createSelector(
    getRegisterState,
    registerReducers.getInviteHash
);

export const getStep = createSelector(
    getRegisterState,
    registerReducers.getStep
);

export const getRegisterBannerStatus = createSelector(
    getRegisterState,
    registerReducers.getRegisterBannerStatus
);

export const getRegisterBannerMessage = createSelector(
    getRegisterState,
    registerReducers.getRegisterBannerMessage
);

export const getRegisterBannerColor = createSelector(
    getRegisterState,
    registerReducers.getRegisterBannerColor
);

export const getRegisterProgressBar = createSelector(
    getRegisterState,
    registerReducers.getRegisterProgressBar
);

export const getDistrictRegistrationPayload = createSelector(
    getRegisterState,
    registerReducers.getDistrictRegistrationPayload
);
